
import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: "うちは熟練者がいるので要りません。",
      answer: "熟練者は\"改善\"へ、段取りは仕組みに。属人化を外し、夜間・多台持ち対応が可能になります。熟練者の技術をシステム化することで、より価値の高い業務に集中できます。"
    },
    {
      question: "当社はそこまでの精度は要らない",
      answer: "狙いは\"過剰精度\"でなく\"再現性\"。振れ・高さが日替わりだと工程能力が乱れ、仕上げパス増・刃具費増に直結します。再現性＝コストの安定です。"
    },
    {
      question: "プリセッター分の時間が増えませんか？",
      answer: "機械が削っている間にプリセットできるため、停止時間が純減します。並行作業により、全体の生産性が向上します。"
    },
    {
      question: "試し削りを完全ゼロにできますか？",
      answer: "安全確認の\"1回のみ\"を推奨する現場もあります。それでも試し削りの90％以上は消滅します。完全ゼロを目指すより、大幅削減による効果が重要です。"
    },
    {
      question: "ＮＣとの接続や教育が不安です。",
      answer: "主要NCと接続実績あり。2-3日のトレーニングで現場運用が可能です。教育用ビデオも有りますのでご安心ください。導入後のサポート体制も充実しています。"
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            よくある疑問と回答
          </h2>
        </div>
        
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-8 py-6 text-left flex justify-between items-center hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <div>
                  <span className="text-yellow-600 font-bold mr-3">Q{index + 1}.</span>
                  <span className="text-lg font-semibold text-gray-900">{faq.question}</span>
                </div>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-gray-400 transition-transform`}></i>
              </button>
              
              {openIndex === index && (
                <div className="px-8 pb-6">
                  <div className="border-t border-gray-200 pt-4">
                    <span className="text-black font-bold mr-3">A.</span>
                    <span className="text-gray-600 leading-relaxed">{faq.answer}</span>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
